// ===== RB Sibling Colour Swap (Roobear) =====
// Colours are separate products, so swatches are plain links. This swaps #MainContent
// in place (no reload): fetch the sibling PDP, replace the content, re-run its inline
// scripts, re-init the theme sections via window.Shopify.theme.sections, rebind the
// sticky ATC bar, reload Judge.me, pushState the URL. Any failure -> normal navigation.
// Sold-out colours navigate normally so RestockRocket loads fresh. Analytics re-fires
// live in rb-sibling-analytics.js (listens for rb:sibling:swap). Loaded from
// snippets/product-siblings.liquid.
(function () {
  if (window.RB_SIBLING_SWAP) return;
  window.RB_SIBLING_SWAP = true;

  var LINK = '.siblings__link';
  var MAIN = '#MainContent';
  var PRODUCT = '[data-section-type="product"]';
  var RB_GLOBALS = ['RB_VARIANTS', 'RB_PRICE_HTML', 'RB_PRICE_KEY', 'RB_COUNTDOWN_HTML', 'RB_BACKORDER'];
  var CACHE_MS = 60000;

  var state = { handle: handleOf(location.pathname), token: 0, swapped: false, cache: {} };

  function handleOf(path) {
    var m = (path || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function withPreview(url) {
    var m = location.search.match(/[?&](preview_theme_id=\d+)/);
    if (!m || /[?&]preview_theme_id=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + m[1];
  }

  function getPage(url) {
    var hit = state.cache[url];
    if (hit && Date.now() - hit.t < CACHE_MS) return hit.p;
    var p = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    });
    state.cache[url] = { t: Date.now(), p: p };
    p.catch(function () { delete state.cache[url]; });
    return p;
  }

  // The theme only reacts to shopify:section:load in the theme editor, so call the
  // onUnload / onLoad hooks from its section registry directly.
  function sectionContainers(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-section-id][data-section-type]'));
  }

  function runHooks(container, hook) {
    var sections = window.Shopify && Shopify.theme && Shopify.theme.sections;
    var reg = sections && sections.registered && sections.registered[container.getAttribute('data-section-type')];
    var fns = reg && reg.callStack && reg.callStack[hook];
    if (!fns) return;
    var props = { id: container.getAttribute('data-section-id'), type: container.getAttribute('data-section-type'), container: container };
    for (var i = 0; i < fns.length; i++) {
      try { fns[i].call(props); } catch (e) { if (window.console) console.warn('[sibling swap] ' + hook + ' failed for ' + props.type, e); }
    }
  }

  function unloadSections(root) {
    var list = sectionContainers(root);
    var inst = window.Shopify && Shopify.theme && Shopify.theme.sections && Shopify.theme.sections.instances;
    for (var i = 0; i < list.length; i++) {
      runHooks(list[i], 'onUnload');
      if (inst) {
        for (var j = inst.length - 1; j >= 0; j--) { if (inst[j] && inst[j].container === list[i]) inst.splice(j, 1); }
      }
    }
  }

  function loadSections(root) {
    var list = sectionContainers(root);
    for (var i = 0; i < list.length; i++) runHooks(list[i], 'onLoad');
  }

  // innerHTML does not execute scripts: re-run the inline ones (RB_* data, complete-the-set,
  // Judge.me data). External <script src> tags are already loaded.
  function runInlineScripts(root) {
    for (var g = 0; g < RB_GLOBALS.length; g++) {
      try { delete window[RB_GLOBALS[g]]; } catch (e) { window[RB_GLOBALS[g]] = undefined; }
    }
    var scripts = root.querySelectorAll('script:not([src])');
    for (var i = 0; i < scripts.length; i++) {
      var s = scripts[i];
      var type = (s.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'application/javascript') continue;
      var code = s.textContent || '';
      if (!code.replace(/\s+/g, '')) continue;
      var n = document.createElement('script');
      n.text = code;
      try { s.parentNode.replaceChild(n, s); } catch (e) {}
    }
  }

  function syncHead(doc) {
    var sels = [
      ['link[rel="canonical"]', 'href'],
      ['meta[name="description"]', 'content'],
      ['meta[property="og:title"]', 'content'],
      ['meta[property="og:url"]', 'content'],
      ['meta[property="og:image"]', 'content'],
      ['meta[property="og:description"]', 'content'],
      ['meta[property="og:price:amount"]', 'content']
    ];
    for (var i = 0; i < sels.length; i++) {
      var a = document.head.querySelector(sels[i][0]);
      var b = doc.head.querySelector(sels[i][0]);
      if (a && b) a.setAttribute(sels[i][1], b.getAttribute(sels[i][1]) || '');
    }
    if (doc.title) document.title = doc.title;
  }

  // Sticky ATC bar: custom.js binds it once at load; re-bind the new nodes here.
  // Mirrors initStickyATC() in custom.js - keep the two in step.
  var stickyCleanup = null;
  function rebindSticky() {
    if (stickyCleanup) { try { stickyCleanup(); } catch (e) {} stickyCleanup = null; }
    var bar = document.getElementById('sticky-atc-bar');
    var trigger = document.getElementById('sticky-atc-trigger');
    var nativeBtn = document.querySelector('[data-native-atc]');
    var stickyMeta = document.getElementById('sticky-atc-meta');
    var stickyPrice = document.getElementById('sticky-atc-price');
    var stickyDot = document.getElementById('sticky-atc-dot');
    var stickyBtnText = document.getElementById('sticky-atc-btn-text');
    var cfg = document.querySelector('[data-rb-add]');
    if (!bar || !nativeBtn) return;

    function cfgText(attr, fallback) { return (cfg && cfg.getAttribute(attr)) || fallback; }
    function notifyButton() { return document.querySelector('.restock-rocket-button-cover, .restock-rocket-button'); }
    function notifyEnabled() {
      var c = window._RestockRocketConfig;
      var off = c && c.disabledNotifyMeVariantIds;
      if (!off || !off.length) return true;
      var idEl = document.querySelector('[name="id"]');
      var id = idEl && idEl.value;
      return off.indexOf(Number(id)) === -1 && off.indexOf(String(id)) === -1;
    }
    function setStickyState(available) {
      if (!trigger) return;
      var notify = !available && notifyEnabled();
      var label;
      if (available) {
        label = cfgText('data-rb-is-preorder') === '1' ? cfgText('data-rb-preorder', 'Add to Cart') : cfgText('data-rb-add', 'Add to Cart');
      } else {
        label = notify ? cfgText('data-rb-notify', 'Notify me when available') : cfgText('data-rb-soldout', 'Sold Out');
      }
      trigger.setAttribute('data-rb-state', notify ? 'notify' : (available ? 'add' : 'soldout'));
      trigger.disabled = !available && !notify;
      if (stickyBtnText) stickyBtnText.textContent = label;
      trigger.setAttribute('aria-label', label);
      if (stickyPrice) stickyPrice.hidden = !available;
      if (stickyDot) stickyDot.hidden = !available;
    }
    function updateBarVisibility() {
      var rect = nativeBtn.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }
    function updateStickyMeta(variant) {
      if (!stickyMeta) return;
      var parts = [];
      if (variant && variant.title && variant.title !== 'Default Title') parts = variant.title.split(' / ');
      stickyMeta.textContent = parts.join(' · ');
    }
    function updateStickyPrice(price) {
      if (!stickyPrice) return;
      stickyPrice.textContent = window.Shopify && Shopify.formatMoney
        ? Shopify.formatMoney(price, '{{ amount }}')
        : '$' + (price / 100).toFixed(2);
    }

    if (trigger) {
      trigger.addEventListener('click', function () {
        if (trigger.getAttribute('data-rb-state') === 'notify') {
          var rr = notifyButton();
          if (rr) { rr.click(); return; }
          nativeBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var realBtn = document.querySelector('[data-add-to-cart]');
        if (realBtn && !realBtn.disabled) realBtn.click();
      });
    }

    function onVariant(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      updateStickyMeta(variant);
      updateStickyPrice(variant.price);
      setStickyState(variant.available !== false);
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { updateBarVisibility(); ticking = false; });
    }
    document.addEventListener('theme:variant:change', onVariant);
    window.addEventListener('scroll', onScroll, { passive: true });
    stickyCleanup = function () {
      document.removeEventListener('theme:variant:change', onVariant);
      window.removeEventListener('scroll', onScroll);
    };

    updateBarVisibility();
    setStickyState(!nativeBtn.disabled);
    setTimeout(function () { setStickyState(!nativeBtn.disabled); }, 1500);
  }

  // Mirrors patchChangeVariant() in custom.js for the new productForm() component.
  function patchProductForm() {
    try {
      var section = document.querySelector(PRODUCT);
      var xroot = section && section.querySelector('[x-data]');
      var data = xroot && window.Alpine && window.Alpine.$data(xroot);
      if (!data || typeof data.changeVariant !== 'function') return false;
      if (data.__rbPatched) return true;
      data.__rbPatched = true;
      var orig = data.changeVariant.bind(data);
      data.changeVariant = function (variantUrl, newVariantId, variantMediaId) {
        if (window.RB_VARIANTS && newVariantId != null && window.RB_VARIANTS[newVariantId]) {
          if (this.variantId !== newVariantId) this.variantId = newVariantId;
          if (window.RB && typeof window.RB.apply === 'function') window.RB.apply(null, newVariantId, variantUrl);
          this.updateProductImage(variantMediaId);
          return Promise.resolve();
        }
        return orig.call(this, variantUrl, newVariantId, variantMediaId);
      };
      return true;
    } catch (e) { return false; }
  }

  // Judge.me builds widgets once at load; re-run its module (cache-busted: modules run
  // once per URL) so the new product's reviews render.
  function reloadJudgeMe() {
    try {
      if (!document.querySelector(MAIN + ' .jdgm-widget')) return;
      var orig = document.querySelector('script[src*="review_widget.js"]');
      if (orig) {
        var n = document.createElement('script');
        n.type = 'module';
        n.src = orig.src + (orig.src.indexOf('?') > -1 ? '&' : '?') + 'rb=' + Date.now();
        n.onload = n.onerror = function () { if (n.parentNode) n.parentNode.removeChild(n); };
        document.body.appendChild(n);
      }
      if (window.jdgm) {
        if (typeof window.jdgm.customizeBadges === 'function') window.jdgm.customizeBadges();
        if (typeof window.jdgm.batchRenderBadges === 'function') window.jdgm.batchRenderBadges();
      }
    } catch (e) {}
  }

  function afterInit(url, handle, doc) {
    var RB = window.RB;
    try { rebindSticky(); } catch (e) {}

    var tries = 0;
    (function whenReady() {
      if (patchProductForm()) {
        if (RB && typeof RB.preloadImages === 'function') RB.preloadImages();
        if (RB && typeof RB.applyOptionStates === 'function') RB.applyOptionStates();
        return;
      }
      if (++tries < 60) window.requestAnimationFrame(whenReady);
    })();

    reloadJudgeMe();

    document.dispatchEvent(new CustomEvent('rb:sibling:swap', { detail: { url: url, handle: handle, title: document.title, doc: doc } }));
  }

  function swap(url, push) {
    var token = ++state.token;
    return getPage(url).then(function (html) {
      if (token !== state.token) return false; // a newer click superseded this one
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var curMain = document.querySelector(MAIN);
      var newMain = doc.querySelector(MAIN);
      var handle = handleOf(new URL(url, location.href).pathname);
      var newProduct = newMain && newMain.querySelector(PRODUCT);
      if (!curMain || !newProduct || newProduct.getAttribute('data-product-handle') !== handle) {
        throw new Error('unexpected page structure');
      }

      var y = window.pageYOffset;
      var a = document.activeElement;
      var hadFocus = !!(a && a.closest && a.closest(LINK));
      unloadSections(curMain);
      curMain.innerHTML = newMain.innerHTML;
      // URL + head first: the re-run inline scripts (complete-the-set, Judge.me) read location.
      syncHead(doc);
      if (push) {
        try {
          // The theme's x-router stamps the landing entry {fromRouter:true} and reloads on
          // popstate to it. Clear the flag so Back to the first colour swaps too.
          var hs = window.history.state;
          if (hs && hs.fromRouter) window.history.replaceState({ rbSibling: true }, '', location.href);
          window.history.pushState({ rbSibling: true }, '', url);
        } catch (e) {}
      }
      state.handle = handle;
      state.swapped = true;
      runInlineScripts(curMain);
      loadSections(curMain);
      window.scrollTo(0, y);
      if (hadFocus) {
        var cur = document.querySelector(LINK + '.siblings__link--current');
        if (cur) cur.focus({ preventScroll: true });
      }
      afterInit(url, handle, doc);
      return true;
    });
  }

  function go(a) {
    var url = withPreview(a.href);
    var row = a.closest('[data-swapper-wrapper]');
    if (row) {
      var all = row.querySelectorAll(LINK);
      for (var i = 0; i < all.length; i++) {
        all[i].classList.remove('siblings__link--current');
        all[i].removeAttribute('aria-current');
      }
      a.classList.add('siblings__link--current');
      a.setAttribute('aria-current', 'true');
      var label = row.querySelector('[data-swapper-target]');
      if (label) label.textContent = a.getAttribute('data-swapper-hover') || a.title || label.textContent;
    }
    swap(url, true).catch(function () {
      window.location.assign(url);
    });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest(LINK);
    if (!a) return;
    if (a.classList.contains('siblings__link--sold-out')) return; // normal navigation
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || !handleOf(u.pathname)) return;
    if (!document.querySelector(MAIN + ' ' + PRODUCT)) return;
    e.preventDefault();
    if (a.classList.contains('siblings__link--current')) return;
    go(a);
  });

  function prefetch(e) {
    var a = e.target.closest && e.target.closest(LINK);
    if (!a || a.classList.contains('siblings__link--current') || a.classList.contains('siblings__link--sold-out')) return;
    try { getPage(withPreview(a.href)).catch(function () {}); } catch (err) {}
  }
  document.addEventListener('mouseover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);

  window.addEventListener('popstate', function () {
    var h = handleOf(location.pathname);
    if (!state.swapped || !h || h === state.handle) return;
    swap(location.href, false).catch(function () { window.location.reload(); });
  });
})();
